import { useState, useEffect, useCallback } from "react";
import { getListings } from "../../service/listing/listingService";

const PAGE_SIZE = 10;

export const useListings = () => {
  const [listings, setListings] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  // Function to fetch listings for a given page
  const fetchListings = useCallback(async (pageNum) => {
    setLoading(true);
    setError(null);
    try {
      const newItems = await getListings(pageNum, PAGE_SIZE);
      if (pageNum === 1) {
        setListings(newItems);
      } else {
        setListings((prev) => [...prev, ...newItems]);
      }
      setPage(pageNum + 1);
      setHasMore(newItems.length === PAGE_SIZE);
    } catch (e) {
      setError("Không thể tải dữ liệu.");
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  }, []);

  // Initial fetch on component mount
  useEffect(() => {
    fetchListings(1);
  }, [fetchListings]);

  // Function to be called by the component to load more items
  const loadMore = useCallback(() => {
    if (loading || !hasMore) return;
    fetchListings(page);
  }, [loading, hasMore, page, fetchListings]);

  return {
    displayedListings: listings, // For compatibility
    loading,
    error,
    hasMore,
    loadMore,
    // allListings is intentionally removed
  };
};